<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-exclamation-triangle', fontSet: 'fad'}"
	[headerText]="T.ABORT_ASSESMENT_DIALOG_HEADER | translate"
	[matDialogData]="data"
	[rect]="rect"
>
	<form [formGroup]="abortAssessmentForm" dialogContent>
		<mat-form-field class="full-width-form" color="accent">
			<mat-label>{{ T.ABORT_ASSESSMENT_REASON | translate }}</mat-label>
			<textarea
				[cdkAutosizeMaxRows]="5"
				[placeholder]="T.ABORT_ASSESSMENT_PLACEHOLDER | translate"
				[cdkTextareaAutosize]="true"
				[formControl]="abortAssessmentForm.controls.reason"
				matInput
				rows="3"
			>
			</textarea>
			@if (abortAssessmentForm.controls.reason.hasError("minlength")) {
				<mat-error>
					{{
						T.ABORT_ASSESSMENT_MIN_LENGTH
							| translate: {minLength: abortAssessmentForm.controls.reason.errors.minlength.requiredLength}
					}}
				</mat-error>
			}
		</mat-form-field>
	</form>

	<ng-container actions>
		<sim-button (onClick)="close()" [icon]="{fontSet: 'fad', fontIcon: 'fa-times'}" [label]="T.BUTTON_CANCEL" color="primary" />

		<sim-button
			(onClick)="close({action: 'ok', reason: abortAssessmentForm.value.reason})"
			[disabled]="abortAssessmentForm.invalid"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-exclamation-triangle'}"
			[label]="T.ASSESSMENT_PANE_ABORT_BUTTON"
			color="warn"
		/>
	</ng-container>
</sim-basic-material-dialog>
